/** Segment condition formats returned by SegmentOut (see SEGMENTS_FRONTEND.md). */
export const CONDITIONS_FORMAT_LOYALTY_AST = "loyalty_ast";
export const CONDITIONS_FORMAT_UNOMI_ONLY = "unomi_only";

/**
 * Resolve how the UI should edit/display segment conditions.
 */
export function resolveConditionsFormat(segment) {
    const fmt = segment?.conditions_format;
    if (fmt === CONDITIONS_FORMAT_UNOMI_ONLY || fmt === CONDITIONS_FORMAT_LOYALTY_AST) {
        return fmt;
    }
    if (segment?.unomi_condition && !segment?.conditions) {
        return CONDITIONS_FORMAT_UNOMI_ONLY;
    }
    return CONDITIONS_FORMAT_LOYALTY_AST;
}

export function usesLoyaltyConditionBuilder(segment) {
    return resolveConditionsFormat(segment) !== CONDITIONS_FORMAT_UNOMI_ONLY;
}

export function isUnomiOnlySegment(segment) {
    return resolveConditionsFormat(segment) === CONDITIONS_FORMAT_UNOMI_ONLY;
}

/**
 * Recompute / GET …/members?refresh=true : nécessite un AST loyalty évaluable.
 * Segments CDP only (`unomi_only`) : condition uniquement dans Unomi → pas de recalcul AST.
 */
export function canRecomputeDynamicSegment(segment) {
    return Boolean(segment?.is_dynamic) && !isUnomiOnlySegment(segment);
}

export function canRefreshDynamicSegmentMembers(segment) {
    return canRecomputeDynamicSegment(segment);
}

export function formatUnomiConditionJson(unomiCondition) {
    if (unomiCondition == null) return "";
    try {
        return JSON.stringify(unomiCondition, null, 2);
    } catch {
        return String(unomiCondition);
    }
}

export function parseUnomiConditionJson(text) {
    const trimmed = (text || "").trim();
    if (!trimmed) return null;
    return JSON.parse(trimmed);
}
